"use client";

import CountryContactPage from "@/components/Contact/CountryContactPage";

export default function Global() {
  // Global page shows only the Business Hours panel (no form per Figma).
  return <CountryContactPage headquarters="global" fallbackIndex={0} hideForm />;
}
